import React from 'react';
import Flatpickr from "react-flatpickr";
import {Russian} from 'flatpickr/dist/l10n/ru';
import {Input} from 'uikit';
import DatePickerIcon from "@/assets/images/icons/16/calendar.svg";
import ArrowIcon from "@/assets/images/icons/16/arrow.svg";
import CrossIcon from "uikit/src/assets/icons/16/cross.svg";
import styles from '../Form.module.scss'

export interface DatePickerProps {
    undefinedName: string;
    label: string;
    value: string | null;
    utc: string;
    error: string | null;
    onChange: (value: string) => void;
    'data-testid'?: string;
}

const options: Flatpickr.Options.Options = {
    dateFormat: "m-d-Y",
    monthSelectorType: "static",
    allowInput: true,
    disableMobile: true,
    locale: Russian,
    position: "auto",
    minDate: "today"
};

const DatePicker: React.FC<DatePickerProps> = ({undefinedName, label, error, value, utc, onChange, ['data-testid']: testId}) => {
    const isUndefinedValue = value === '—';
    const parsedDate = !isUndefinedValue && value ? new Date(value) : null;

    const formatWithBackendUtc = (date: Date): string => {
        const pad = (n: number) => String(n).padStart(2, '0');
        const yyyy = date.getFullYear();
        const mm = pad(date.getMonth() + 1);
        const dd = pad(date.getDate());
        const hh = pad(date.getHours());
        const mi = pad(date.getMinutes());
        const ss = pad(date.getSeconds());

        return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}${utc}`;
    };

    return (
        <Flatpickr
            options={{...options}}
            onChange={(date) => {
                const selectedDate = date?.[0];
                if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
                    onChange(formatWithBackendUtc(selectedDate));
                } else {
                    onChange(null);
                }
            }}
            value={parsedDate}
            render={({value: _val, defaultValue}, ref) => (
                <div ref={ref}>
                    <Input
                        data-testid={testId}
                        onChange={() => null}
                        className={styles.datePicker}
                        value={
                            isUndefinedValue
                                ? undefinedName
                                : parsedDate?.toLocaleDateString('ru-RU') ?? ''
                        }
                        error={error}
                        label={label}
                        size="small"
                        placeholder="дд.мм.гггг."
                        prefix={<DatePickerIcon/>}
                        suffix={
                            parsedDate ? (
                                <CrossIcon
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onChange(null);
                                    }}
                                />
                            ) : (
                                <ArrowIcon/>
                            )
                        }
                    />
                </div>
            )}
        />
    );
};


export default DatePicker;
